var _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSelectorCornerNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 46,
    viewBox: "0 0 33 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57034 45H1V1H2.57037C4.00473 1 5.40445 1.44063 6.58016 2.26227L28.044 17.2623C32.031 20.0485 32.031 25.9515 28.044 28.7377L6.58016 43.7377C5.40445 44.5594 4.0047 45 2.57034 45Z",
    fill: "#EBF7F6",
    stroke: "#33A9A0",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 3,
    height: 42,
    fill: "#EBF7F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectorCornerNormal);
export default __webpack_public_path__ + "static/media/selector-corner-normal.e79c67f7e8064b7959be3f6ac97a19a4.svg";
export { ForwardRef as ReactComponent };